export enum AppRoute {
  Landing = "/",
  Login = "/login",
  Results = "/results",
  LifeAge = "/life-age",
  FAQ = "/faq",
  Registration = "/a",
  RegistrationAlt = "/r",
  ClientOrder = "/clientorder"
}
